// define states of action taking
export const ActionType = Object.freeze({
	VIEW: '/view',
	CLICK: '/click',
	COMPLETE: '/complete'
});